export const FETCH_NOTIFICATIONS = 'notification/FETCH_NOTIFICATIONS'
export const FETCH_NOTIFICATIONS_SUCCESS = 'notification/FETCH_NOTIFICATIONS_SUCCESS'
export const FETCH_NOTIFICATIONS_FAILURE = 'notification/FETCH_NOTIFICATIONS_FAILURE'
export const RESET_NOTIFICATIONS = 'notification/RESET_NOTIFICATIONS'


// WEBPACK FOOTER //
// ./src/store/notification/actionTypes.js